<script lang="ts">
	import { push } from 'svelte-spa-router';
	import { Breadcrumbs, IconButton } from '@Shelly/shelly-design-system';
	import { deriveRoomName } from '../../../helpers/service_rooms_helpers';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	import { format } from 'src/services/i18n';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let id: string;

	const backBtnClick = () => {
		const roomBackRoute = '/home/rooms/-1';

		setSidePanelState({
			type: roomBackRoute,
			id: '-1',
		});

		push(roomBackRoute);
	};
</script>

{#if id !== '-1'}
	<div
		class={classMap({
			'd-flex width-full': true,
			'align-items-center gap-s': $showNewLayout,
		})}
	>
		<IconButton
			class={classMap({ 'mr-s': !$showNewLayout })}
			variant="secondary"
			icon="fas fa-chevron-left"
			on:click={backBtnClick}
			aria-label={$format('aria_back_room', { default: 'Back to room list' })}
		/>
		<Breadcrumbs
			{...$showNewLayout ? { listClasses: 'width-full' } : {}}
			aria-label={$format('wizard_step_room', { default: 'Room' })}
			links={[{ label: deriveRoomName(id) }]}
			class={classMap({
				'flex-overflow-hidden': !$showNewLayout,
				'flex-1 min-width-0 max-width-fit-content': $showNewLayout,
			})}
		/>
	</div>
{/if}
